import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { useDict } from '../../../contexts/LanguageContext';
import ROUTE_NAME from '../../../routes/RouteName';
import FaqContainer from './FaqContainer';

const Eligibility = () => {
    const dict = useDict();

    return (
        <FaqContainer
            navigationActive="eligibility"
            prevLink={ROUTE_NAME.FAQ_GENERAL_ENQUIRIES}
            prevTitle={dict.generalEnquiries}
            nextLink={ROUTE_NAME.FAQ_REGISTRATION_PROCESS}
            nextTitle={dict.registrationProcess}
        >
            <Card className="card--not-full-height">
                <CardBody className="documentation__card-body">
                    <div className="card__title">
                        <h3 className="bold-text" style={{ color: '#264391' }}>
                            {dict.financingPlatform}
                        </h3>
                    </div>
                    <div className="card__title">
                        <h4 className="bold-text" style={{ color: '#264391' }}>
                            {dict.eligibility}
                        </h4>
                    </div>
                    <p>
                        <strong>
                            {dict.eligibilityTitle1}
                        </strong>
                    </p>
                    <p>
                        {dict.eligibilityTitle1Text1}
                    </p>
                    <ul>
                        <li>{dict.eligibilityTitle1Text1List1}</li>
                        <li>{dict.eligibilityTitle1Text1List2}</li>
                        <li>{dict.eligibilityTitle1Text1List3}</li>
                    </ul>
                    <p>
                        <strong>
                            {dict.eligibilityTitle2}
                        </strong>
                    </p>
                    <p>
                        {dict.eligibilityTitle2Text1}
                    </p>
                    <p>
                        <strong>
                            {dict.eligibilityTitle3}
                        </strong>
                    </p>
                    <p>
                        {dict.eligibilityTitle3Text1}
                    </p>
                    <p>
                        {dict.eligibilityTitle3Text2}
                    </p>
                    <ul>
                        <li>{dict.eligibilityTitle3Text2List1}</li>
                        <li>{dict.eligibilityTitle3Text2List2}</li>
                        <li>{dict.eligibilityTitle3Text2List3}</li>
                    </ul>
                    <p>
                        <strong>
                            {dict.eligibilityTitle4}
                        </strong>
                    </p>
                    <p>
                        {dict.eligibilityTitle4Text1}
                    </p>
                    <p>
                        {dict.eligibilityTitle4Text2}
                    </p>
                    <ul>
                        <li>{dict.eligibilityTitle4Text2List1}</li>
                        <li>{dict.eligibilityTitle4Text2List2}</li>
                        <li>{dict.eligibilityTitle4Text2List3}</li>
                        <li>{dict.eligibilityTitle4Text2List4}</li>
                        <li>{dict.eligibilityTitle4Text2List5}</li>
                    </ul>
                    <p>
                        <strong>
                            {dict.eligibilityTitle5}
                        </strong>
                    </p>
                    <p>
                        {dict.eligibilityTitle5Text1}
                    </p>
                </CardBody>
            </Card>
        </FaqContainer>
    );
};

export default Eligibility;
